import React, { useEffect, useState } from 'react'
import { Button } from '../../../helpers'

import { numberConversion } from '../../../utils';

const Manufacture = (props) => {
    const {
        isConsumptionDataVisible,
        consumptionData,
        consumableInStockData,
        uniqueCreatedMaterialIds,
        selectedCreatedMaterialId,
        creationData,
        enteredQtyToManufacure,
        selectedWarehouseId,
        createdMaterialIdList,
        handleStockAdjForManufacture
    } = props;


    const handleConfirm = () => {
        let stockAdjObjects = []
        const updatedConsumptionData = consumptionData.flatMap(item => item)
        const negativeStockAdj = updatedConsumptionData.map((eachconsumptiondata) => {
            return {
                sellerPONo: parseFloat(eachconsumptiondata.sellerPoNo),
                materialId: eachconsumptiondata.materialId,
                isPositiveAdjustment: false,
                adjustedQty: eachconsumptiondata.qty,
                warehouseId: selectedWarehouseId
            }

        })
        const totalPurchaseAmount = updatedConsumptionData.reduce((sum, item) => sum + item.purchaseAmount, 0)

        const maxPurchaseValueObject = updatedConsumptionData.reduce((maxObj, item) => {
            return item.purchaseAmount > maxObj.purchaseAmount ? item : maxObj
        }, updatedConsumptionData[0])

        const maxGstRate = createdMaterialIdList.filter(item => item.createdMaterialId === selectedCreatedMaterialId)
            .reduce((max, item) => Math.max(max, item.gstRate), 0)

        const positiveStockAdj = {
            adjustedQty: parseFloat(enteredQtyToManufacure),
            isPositiveAdjustment: true,
            warehouseId: selectedWarehouseId,
            sellerPONo: parseFloat(maxPurchaseValueObject.sellerPoNo),
            materialId: selectedCreatedMaterialId,
            GSTRate: maxGstRate,
            unitPrice: parseFloat((totalPurchaseAmount / enteredQtyToManufacure).toFixed(3)),
            sellerPOId: maxPurchaseValueObject.sellerPOId
        }

        stockAdjObjects = [...negativeStockAdj, positiveStockAdj]
        handleStockAdjForManufacture(stockAdjObjects)

    }
    return (
        <div>
            {isConsumptionDataVisible && (
                <div className='p-card mt-2 mb-4'>
                    {(
                        <>
                            <p style={{ fontSize: '14px', fontWeight: 'bold' }}>CONSUMPTION DETAILS </p>
                            {consumptionData.map((eachconsumptiondata, idx) => {
                                const relatedMaterialDetail = consumableInStockData?.find(each => each?.materialId === eachconsumptiondata[0].materialId)
                                const totalPurchaseAmount = eachconsumptiondata.reduce((acc, curr) => acc + (curr.purchaseAmount || 0), 0)
                                return (
                                    <div key={idx} className='p-card mt-3' style={{ width: '100%' }}>
                                        <p style={{ fontSize: '12px', fontWeight: '300' }}> {relatedMaterialDetail?.materialDetails} </p>
                                        <table className="custom-table">
                                            <thead>
                                                <tr className="cunsumption-table-tr">
                                                    <th className="custom-th">SR</th>
                                                    <th className="custom-th">Seller PO No</th>
                                                    <th className="custom-th">Quantity</th>
                                                    <th className="custom-th">Price</th>
                                                    <th className="custom-th">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                                {eachconsumptiondata.map((eachProductItem, index) => (
                                                    <tr className="custom-tr" key={index} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                        <td className="custom-td">{index + 1}</td>
                                                        <td className="custom-td">{eachProductItem.sellerPoNo}</td>
                                                        <td className="custom-td">{parseFloat(eachProductItem.qty).toFixed(3)}</td>
                                                        <td className="custom-td">{eachProductItem.price}</td>
                                                        <td className="custom-td">{numberConversion(eachProductItem.purchaseAmount)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div style={{ display: 'flex', marginTop: '-19px', fontSize: "12px", borderCollapse: "collapse" }}>
                                            <p><b>Total Value:</b> {numberConversion(totalPurchaseAmount)}  </p>
                                        </div>
                                    </div>
                                )
                            })}
                        </>
                    )}
                    <div className="hr-line" style={{ backgroundColor: "#c0c2c4" }} />
                    <p style={{ fontSize: '14px', fontWeight: 'bold' }}>CREATION DETAILS</p>
                    <div className='p-card' style={{ width: '100%' }}>
                        {(() => {
                            const relatedMaterialDetails = uniqueCreatedMaterialIds?.find(each => each.materialId === selectedCreatedMaterialId)
                            return (
                                <>
                                    <p style={{ fontSize: '12px', fontWeight: '300' }}>{relatedMaterialDetails?.materialDetails}</p>
                                    <table className="custom-table">
                                        <thead>
                                            <tr className="creation-table-tr">
                                                <th className="custom-th">SR</th>
                                                <th className="custom-th">Material ID</th>
                                                <th className="custom-th">Seller PO No</th>
                                                <th className="custom-th">Qty</th>
                                                <th className="custom-th">Price</th>
                                                <th className="custom-th">Total Value</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                            <tr className="custom-tr" key={selectedCreatedMaterialId} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="custom-td"> 1 </td>
                                                <td className="custom-td">{creationData.materialId}</td>
                                                <td className="custom-td">{creationData.sellerPONo}</td>
                                                <td className="custom-td">{creationData.createdQty}</td>
                                                <td className="custom-td">{creationData.price.toFixed(3)}</td>
                                                <td className="custom-td">{numberConversion(creationData.amount)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </>
                            )
                        })()}
                    </div>
                    <div className="flex flex-row mt-4 justify-content-center">
                        <Button className="small-btn" label="confirm" onClick={handleConfirm} />
                    </div>
                </div>
            )}

        </div>
    )
}

export default Manufacture
